import { withTranslation } from 'react-i18next';

import { SHIPPO_DE_ADDRESS, SHIPPO_US_ADDRESS } from '~/constants/shippo-addresses';
import { type InjectedTranslateProps } from '~/utils/translate';

interface OwnProps {
  isGerman: boolean;
}

const ShippoInvoiceAddress = (props: InjectedTranslateProps & OwnProps) => {
  const { isGerman, t } = props;
  const shippoAddress = isGerman ? SHIPPO_DE_ADDRESS : SHIPPO_US_ADDRESS;

  return (
    <>
      <strong>{shippoAddress.company}</strong>
      <br />
      {shippoAddress.street1}
      <br />
      {shippoAddress.street2 && (
        <>
          {shippoAddress.street2}
          <br />
        </>
      )}
      {isGerman ? (
        <>
          {shippoAddress.zip} {shippoAddress.city}
          <br />
          {shippoAddress.country}
          <br />
          <i>{t('account.billing.invoices.download.vatDisclaimer')}</i>
        </>
      ) : (
        `${shippoAddress.city}, ${shippoAddress.state}, ${shippoAddress.zip}`
      )}
    </>
  );
};

const ComposedShippoInvoiceAddress = withTranslation('settings')(ShippoInvoiceAddress);
export default ComposedShippoInvoiceAddress;
